import { CreateProject, UpdateRoleBasedProject } from "@/types/project";

export const defaultCreationValues: CreateProject = {
  name: "",
  crs_number: "",
  client_id: "",
  project_type_id: "",
  invoicing_company_id: "",
  start_date: "",
  end_date: "",
  primary_manager_id: "",
  geolocalization_enabled: false,
  payroll_type_id: undefined,
  contractor_card_required: false,
  contractor_visits_planned_duration_visible: false,
  contractor_visits_editable_by_pr: false,
  contractor_visits_hours_editable_by_contractor: false,
  contractor_visits_confirmable_by_contractor: false,
};

export const defaultUpdateValues: UpdateRoleBasedProject = {
  name: "",
  crs_number: "",
  invoicing_company_id: "",
  primary_manager_id: "",
  geolocalization_enabled: false,
  payroll_type_id: undefined,
  contractor_card_required: false,
  contractor_visits_planned_duration_visible: false,
  contractor_visits_editable_by_pr: false,
  contractor_visits_hours_editable_by_contractor: false,
  contractor_visits_confirmable_by_contractor: false,
};
